<template>
  <div class="order-list tt-custom-tab">
    <div class="search-bar seprator">
      <div class="search-bar" style="margin-bottom:0;">
        <div>
          <el-select style="width:100%;" v-model="form.brand_id" clearable filterable :filter-method="filterSearch"
                     class="input-width" placeholder="礼卡品牌">
            <el-option v-for="item in brandList" :key="item.id" :label="item.brand_name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div style="margin-left:20px;">
          <el-select style="width:140px" v-model="form.currency" class="mobile-select" placeholder="货币"
                     @change="search">
            <el-option v-for="(c, index) in total_currencies" :key="index" :label="c.label"
                       :value="c.value"></el-option>
          </el-select>
        </div>
        <div style="margin-left:20px;">
          <el-select style="width:140px" v-model="form.source_id" class="mobile-select" placeholder="来源">
            <el-option v-for="(status, index) in total_sourceList" :key="index" :label="status.purchase_from"
                       :value="status.id"></el-option>
          </el-select>
        </div>
        <div style="margin-left:20px;">
          <el-select style="width:140px" v-model="form.batch_id" class="mobile-select" placeholder="礼卡批次">
            <el-option v-for="(status, index) in batchList" :key="index" :label="status.gift_card_batch_number"
                       :value="status.id"></el-option>
          </el-select>
        </div>
        <div style="margin-left:20px;">
          <el-select style="width:140px" v-model="form.status" class="mobile-select" placeholder="使用状态">
            <el-option v-for="(status, index) in cardStatusOptions" :key="index" :label="status.label"
                       :value="status.name"></el-option>
          </el-select>
        </div>
      </div>
      <div>
        <el-button type="primary" @click="AddCardsVisible = true">添加礼卡</el-button>
      </div>
    </div>
    <div class="search-bar seprator">
      <div style="display:flex;align-items:center;">
        <span>
          {{ totalCount }}个礼卡&nbsp;&nbsp;
        </span>
      </div>
      <div>
        <div style="display:inline-block;">
          <label>添加时间</label>
          <el-date-picker format="yyyy-MM-dd HH:mm" v-model="timeRange" type="datetimerange" range-separator="至"
                          start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']"
                          @change="search">
          </el-date-picker>
        </div>
        <div style="display:inline-block;">
          <el-input class="commbo-input" style="width:500px;" clearable v-model="searchWord">
            <el-select class="search-preix" v-model="keyword_type" slot="prepend" placeholder="请选择"
                       style="width:120px;">
              <el-option label="礼品卡号" value="1"></el-option>
            </el-select>
            <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
          </el-input>
        </div>
      </div>
    </div>
    <div class="table">
      <div class="table-head">
        <div style="display:flex;align-items: center;width:100%;">
          <div v-for="c in columns" :style="{ width: c.width }">
            {{ c.name }}
          </div>
        </div>
        <div style="opacity:0">
          <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="table-body pool">
        <el-collapse class="customCollapse2" v-model="activeName" @change="changeCollapse" accordion
                     style="width:100%;">
          <el-collapse-item v-for="(r, index) in cardList" :name="index" :key="index">
            <template slot="title">
              <div class="table-row-title" style="line-height:1;width:100%;">
                <div v-for="(c, idx) in columns" :key="idx" :style="{ width: c.width }">
                  <template v-if="c.field == 'icon'">
                    <div style="width: 40px;position: relative;top: -2px;color: #1aad19;">
                      <i style="font-size: 20px;" class="el-icon-bank-card"></i>
                    </div>
                  </template>
                  <template v-if="c.field == 'amount'">
                    <p style="font-size: 20px;">
                      {{ r.currency }}{{ r.balance }}<sub style="font-size:14px;">面值{{ r.face_value }}</sub>
                    </p>
                  </template>
                  <template v-if="c.field == 'card_content'">
                    <p style="font-size: 16px;padding-bottom: 5px;">{{ r.gift_card_number }}</p>
                    <p style="font-size: 16px;">{{ r.gift_card_pin }}</p>
                  </template>
                  <template v-if="c.field == 'status'">
                    <p style="font-size: 16px;">{{ r.status_display }}</p>
                  </template>
                  <template v-else>
                    <p style="font-size: 16px;">{{ r[c.field] }}</p>
                  </template>
                </div>
              </div>
            </template>
            <div class="table-row-content">
              <Card :r="r" :index="index" @addHistoryPatch="addHistoryHandler"></Card>
              <div style="clear:both;"></div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="yd-pagination" v-if="totalCount / form.limit > 1">
      <el-pagination :page-size="form.limit" :pager-count="5" :current-page.sync="form.page" layout="prev, pager, next"
                     next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
      </el-pagination>
    </div>
    <el-dialog top="0" v-if="AddCardsVisible" class="el-dialog-sm custom-width-dialog-900" :close-on-click-modal="false"
               :visible.sync="AddCardsVisible" width="90%">
      <AddCards :brandList="brandList" :currencies="currencies" :sourceList="sourceList"
                @addCardPatch="addPatchHandler">
      </AddCards>
    </el-dialog>
    <el-dialog top="0" v-if="AddHistoryVisible" class="el-dialog-sm custom-width-dialog-900"
               :close-on-click-modal="false"
               :visible.sync="AddHistoryVisible" width="30%">
      <AddHistory :addHistoryVisible="AddHistoryVisible" :currencies="currencies" :merchantList="merchantList"
                  :giftCardNumber="currentRow.gift_card_number" @addHistoryPatch2="addHistoryPatch2"></AddHistory>
    </el-dialog>
  </div>
</template>

<script>
  import Card from './CardBody.vue'
  import AddCards from './AddCards.vue'
  import api from '../../../services/api.js'
  import AddHistory from "./AddHistory";

  let _ = require('lodash')

  export default {
    name: 'OrderList',
    components: {
      AddHistory,
      AddCards: AddCards,
      Card: Card
    },
    data() {
      return {
        currentRow: {},
        AddHistoryVisible: false,
        AddCardsVisible: false,
        account_id: this.$localStorage.get('account_id'),
        activeName: '2',
        cardList: [],
        columns: [
          {name: '', field: 'icon', width: '40px'},
          {name: '礼卡品牌', field: 'brand_name', width: '160px'},
          {name: '余额', field: 'amount', width: '230px'},
          {name: '批次', field: 'gift_card_batch_number', width: '100px'},
          {name: '卡号', field: 'card_content', width: 'calc(100% - 640px)'},
          {name: '状态', field: 'status', width: '80px'},
        ],
        keyword_type: '1',
        searchWord: '',
        cardStatusOptions: [{name: '', label: '礼卡状态'}, {name: '1', label: '新增'}, {name: '2', label: '使用中'}, {
          name: '3',
          label: '重新打开'
        }],
        form: {
          limit: 30,
          page: 1,
          status: '',
          gift_card_number: '',
          brand_id: '',
          source_id: '',
          currency: '',
          batch_id: ''
        },
        totalCount: 0,
        timeRange: [],
        brandList: [],
        brandListOptions: [],
        batchList: [],
        sourceList: [],
        total_sourceList: [],
        currencies: [],
        total_currencies: [],
        merchantList: []
      }
    },
    async mounted() {
      this.timeRange = [new Date(new Date().getTime() - 3 * 24 * 3600 * 1000), new Date()]
      await this.getCardBrandList()
      await this.getCardCurrencies()
      await this.getCardBatchList()
      await this.getCardSourceList()
      await this.getMerchantList()
      this.search()
    },
    methods: {
      getMerchantList() {
        api.getMerchants(this).then(res => {
          this.merchantList = res.body.result
        })
      },
      changeCollapse(val) {
        if (val === '') {
          return;
        }
        this.currentRow = this.cardList[val];
        this.giftCardHistoryList();
      },
      giftCardHistoryList() {
        let param = {gift_card_number: this.currentRow.gift_card_number}
        api.giftCardHistoryList(this, param).then(res => {
          let data = res.body.result.length ? res.body.result : [{}]
          this.currentRow.gift_card_transaction_history_list = data;
        })
      },
      addHistoryHandler(e) {
        this.AddHistoryVisible = true
      },
      addHistoryPatch2(e) {
        this.$message.success('添加成功');
        this.AddHistoryVisible = false;
        this.giftCardHistoryList();
      },
      addPatchHandler() {
        this.AddCardsVisible = false;
        this.form.page = 1;
        this.search()
      },
      async getCardBrandList() {
        let res = await api.getCardBrandList(this, {page: 1, limit: 9999})
        res = res.body
        this.brandList = res.rows
      },
      async getCardCurrencies() {
        let res = await api.getCardCurrencyList(this, {page: 1, limit: 9999})
        res = res.body
        this.currencies = res.result
        this.total_currencies = [{value: '', label: '货币'}].concat(res.result)
      },
      async getCardSourceList() {
        let res = await api.getCardSourceList(this, {page: 1, limit: 9999})
        res = res.body
        this.sourceList = res.rows
        this.total_sourceList = [{id: '', purchase_from: '来源'}].concat(res.rows)
      },
      async getCardBatchList() {
        let res = await api.getCardBatchList(this, {page: 1, limit: 9999})
        res = res.body
        this.batchList = [{id: '', gift_card_batch_number: '礼卡批次'}].concat(res.rows)
      },

      search() {
        const generateParams = () => {
          let params = {}
          params.limit = this.form.limit;
          params.page = this.form.page;
          for (let p in this.form) {
            if (this.form[p])
              params[p] = this.form[p]
          }
          /*if(this.timeRange.length){
            params.start_time=this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm')
            params.end_time=this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm')
          }*/
          if (this.searchWord) {
            switch (this.keyword_type) {
              case '1':
                params.gift_card_number = this.searchWord;
                break;
              case '2':
                params.tracking_number = this.searchWord;
                break;
              case '3':
                params.merchant_order_number = this.searchWord;
                break;
            }
          }
          return params
        }
        let params = generateParams()
        this.getList(params)
      },
      toggleSelect() {
        this.mailList.forEach((m) => {
          m.isSelected = this.selectAll
        })
      },
      generateDateDisplay(datestring) {
        let today = new Date()
        let yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
        let today_string = this.$moment(today).format('YYYY-MM-DD')
        let yest_string = this.$moment(yesterday).format('YYYY-MM-DD')
        if (datestring == today_string)
          return '今天';
        if (datestring == yest_string)
          return '昨天';
        return datestring
      },
      getList(params) {
        api.getCardList(this, params).then((res) => {
          this.cardList = res.body.rows;
          this.cardList.forEach((i) => {
            i.status_display = this.cardStatusOptions.find(c => c.name == i.status).label || '';
          })
          this.totalCount = +res.body.total;
        })
      },
      filterSearch(queryString, cb) {
        this.brandListOptions = []
        let res = this.brandList.filter((i) => {
          return i.brand_name.indexOf(queryString) > -1
        })
        _.each(res, item => {
          this.brandListOptions.push({value: item.brand_name, id: item.id})
        })
        if (callback)
          callback()
      },
    },
    watch: {
      'activeName': (val) => {
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .empty-content {
    padding: 50px 0 50px;
  }
</style>

<style lang="scss">
  .order-list {
    margin-bottom: 80px;

    .el-tabs__content {
      overflow: visible;
    }
  }

  .search-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;

    &.seprator {
      justify-content: space-between;
    }
  }

  .table {
    margin-top: 43px;
    overflow-x: auto;
    overflow-y: hidden;

    .table-head,
    .table-body {
      display: flex;
    }

    .table-head {
      padding: 18px 11px 18px 21px;
      border-left: 2px solid transparent;
      border-right: 2px solid transparent;
    }

    .table-row-title {
      display: flex;
    }

    .table-head {
      color: #888888;
    }

    .seporater-order {
      padding: 0 50px;
      height: 40px;
      border: 1px solid #D7D7D7;
      border-top: none;
      line-height: 40px;
    }

    .table-row-content {
      //display:flex;
      padding: 25px 50px 30px;
      border: 1px solid #D7D7D7;
      border-top: none;

      &.order {
        display: block;
        border-top: 1px solid #D7D7D7;
      }
    }

    .table-row-seperator {
      float: left;
      height: 33px;
      width: 100%;
      border-left: 1pX dashed #D7D7D7;
      border-right: 1px dashed #D7D7D7;
    }
  }

  .yd-pagination {
    margin-top: 30px;
  }

  .redirct {
    font-size: 24px;
    line-height: 33px;
    margin-top: 54px;
    padding-bottom: 70px;

    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }

    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }

  .product-price label.danger {
    font-size: 18px;
    color: #FF4650;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/card/list.vue